import axiosInstance from "./axiosInstance";

export const sendDemoRequest = async (formData) => {
  try {
    const response = await axiosInstance.post(
      "/landing/demo-request",
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Error sending demo request:", error);
    throw error;
  }
};
